import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import TraderListLayer from "../components/TraderListLayer";


const TraderListPage = () => {
  return (
    <>
     
        {/* Breadcrumb */}
        {/* <Breadcrumb title="Trader List" /> */}
        <div className="d-flex justify-content-between"><h5>Traders  </h5><Breadcrumb title="Traders" /></div>

        <TraderListLayer />

     
    </>
  );
};


export default TraderListPage;
